import { useEffect, useState } from 'react';
import { getMessageUsers } from '../../../lib/supabase/actions';
import UsersModal from '../UsersModal';

const types = {
  like: {
    table: 'message_likes',
    title: 'Liked by these',
  },
  insight: {
    table: 'message_insightful',
    title: 'Insighted by these',
  },
  fresh: {
    table: 'message_fresh',
    title: 'Freshed by these',
  },
};

export default function ViewMessageUsersModal({ isOpen, message, type, onClose }) {
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const table = types[type]?.table ?? '';

  useEffect(() => {
    if (isOpen) {
      (async () => {
        try {
          setIsLoading(true);
          const data = await getMessageUsers({ messageId: message.id, table });
          setUsers(data.users);
        } finally {
          setIsLoading(false);
        }
      })();
    }
  }, [message.id, isOpen, table]);

  return (
    <UsersModal
      isOpen={isOpen}
      onClose={onClose}
      title={types[type]?.title}
      users={users}
      isLoading={isLoading}
    />
  );
}
